import { Badge } from "@/components/ui/badge"
import { UserRole } from "@/domain/auth/auth"

const roleLabels: Record<UserRole, string> = {
  [UserRole.Scheduler]: 'Programador',
  [UserRole.SuperAdmin]: 'Super Admin',
  [UserRole.Admin]: 'Admin',
  [UserRole.Secretary]: 'Secretaria',
  [UserRole.Employee]: 'Empleado',
  [UserRole.Client]: 'Cliente',
}

const roleColors: Record<UserRole, string> = {
  [UserRole.Scheduler]: 'bg-cyan-100 text-cyan-800',
  [UserRole.SuperAdmin]: 'bg-purple-100 text-purple-800',
  [UserRole.Admin]: 'bg-red-100 text-red-800',
  [UserRole.Secretary]: 'bg-blue-100 text-blue-800',
  [UserRole.Employee]: 'bg-green-100 text-green-800',
  [UserRole.Client]: 'bg-gray-100 text-gray-800',
}

export const renderUserRoleBadge = (role: UserRole) => {
  return <Badge variant="outline" className={`${roleColors[role]} mr-1`}>
    {roleLabels[role]}
  </Badge>
}